import React, { Component } from 'react'
import ReactModal from 'react-modal'
import { withRouter } from 'react-router-dom'
import { toast } from 'react-toastify'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes, faCheck } from '@fortawesome/free-solid-svg-icons'
import Axios from '../../utils/Axios'
import { connect } from 'react-redux'
import * as UserProfileReducer from '../../redux/reducers/UserProfileReducer'
import { getProduct } from '../../pages/home/Cropper'
import { SubscriptionManager } from '../../utils/Helper'
import { SUBSCRIBE } from '../../constants/Routes'
import instance from '../../utils/Axios'

class UserProfileModal extends Component {
  state = {
    user: null,
    isEditForm: false,
    loading: true,
    cancelSubLoading: false,
  }

  constructor(props) {
    super(props)

    ReactModal.setAppElement('#root')
  }

  INIT = async () => {
    const { user, setUserProfile } = this.props

    if (!user) {
      // fetch user
      const response = await Axios.get('/users/profile')

      this.setState({
        loading: false,
      })

      if (response) {
        setUserProfile(response.data)
        this.setState({
          user: response.data,
        })
      } else {
        console.error(response)
      }
    } else {
      if (!this.state.user) {
        this.setState({
          user: user,
        })
      }
      this.setState({
        loading: false,
      })
    }
  }

  componentDidMount() {
    this.INIT()
  }

  upgradeSubscription = () => {
    this.props.history.push(SUBSCRIBE)
  }

  confirmCancelSubscription = () => {
    if (window.confirm('Are you sure you want to cancel your subscription?')) {
      this.setState({
        cancelSubLoading: true,
      })
      instance
        .post('subscriptions/cancel', {})
        .then((response) => {
          toast.success('Subscription cancelled successfully!')

          setTimeout(() => {
            window.location.reload()
          }, 1000)
        })
        .catch((err) => {
          const errorMessage = err.response?.data?.message || err?.message
          toast.error(errorMessage)
        })
        .finally(() => {
          this.setState({
            cancelSubLoading: false,
          })
        })
    }
  }

  showEditModal = () => {
    this.setState({
      isEditForm: true,
    })
  }

  hideEditModal = () => {
    this.setState({
      isEditForm: false,
      user: this.props.user,
    })
  }

  saveEditModal = async () => {
    this.setState({
      loading: true,
    })

    const response = await Axios.post('/users/profile', {
      name: this.state.user.name.trim(),
      email: this.state.user.email.trim(),
    })

    if (response.status !== 200) {
      alert(response.data.message)
    } else {
      this.props.setUserProfile(response.data)
    }
    this.setState({
      isEditForm: false,
      loading: false,
    })
  }

  onNameChangeHandler = (event) => {
    this.setState({
      user: {
        ...this.state.user,
        name: event.target.value,
      },
    })
  }

  onEmailChangeHandler = (event) => {
    this.setState({
      user: {
        ...this.state.user,
        email: event.target.value,
      },
    })
  }

  render() {
    const { user, isEditForm, loading, cancelSubLoading } = this.state
    const { authUser, mySubscription, products } = this.props
    const subscriptionManager = SubscriptionManager(
      authUser,
      mySubscription,
      products,
    )
    return (
      <>
        <div className="flex items-center flex-col">
          <h4>{loading && 'Loading...'}</h4>
        </div>
        {user && (
          <>
            <p className="infoLines">
              <span>
                <strong>Package :</strong>
              </span>
              <span>
                {getProduct(this.props.mySubscription, this.props.products)
                  ?.type ?? 'No Active Package'}
              </span>
            </p>
            <p className="infoLines">
              <span>
                <strong>Date Created :</strong>
              </span>
              <span>
                {user.date ? new Date(user.date).toDateString() : 'Nil'}
              </span>
            </p>
            <p className="infoLines">
              <span>
                <strong>Subscription :</strong>
              </span>
              <span>
                {this.props.mySubscription?.is_trial_active
                  ? 'Trial (7 days)'
                  : this.props.mySubscription?.active
                  ? 'Paid'
                  : 'Basic'}
              </span>
            </p>

            <p className="infoLines">
              <span>
                <strong>Name :</strong>
              </span>
              <span>
                {isEditForm ? (
                  <input
                    className="border rounded border-teal-700 w-full"
                    style={{ padding: '2px 6px' }}
                    type="text"
                    value={user.name}
                    onChange={this.onNameChangeHandler}
                    disabled={loading}
                  />
                ) : (
                  user.name
                )}
              </span>
            </p>

            <p className="infoLines no-border-bottom">
              <span>
                <strong>Email :</strong>
              </span>
              <span>
                {isEditForm ? (
                  <input
                    className="border rounded border-teal-700 w-full"
                    style={{ padding: '2px 6px' }}
                    type="email"
                    value={user.email}
                    onChange={this.onEmailChangeHandler}
                    disabled={loading}
                  />
                ) : (
                  user.email
                )}
              </span>
            </p>

            <div className="flex items-center mt-4">
              {isEditForm ? (
                <>
                  <button
                    className="rounded bg-teal-700 hover:bg-teal-600 py-2 px-3 mr-2 text-white"
                    onClick={this.saveEditModal}
                    disabled={loading}>
                    <FontAwesomeIcon icon={faCheck} /> Save
                  </button>
                  <button
                    className="rounded bg-gray-700 hover:bg-gray-600 py-2 px-3 mr-2 text-white"
                    onClick={this.hideEditModal}>
                    <FontAwesomeIcon icon={faTimes} /> Cancel
                  </button>
                </>
              ) : (
                <button
                  className="rounded bg-teal-700 hover:bg-teal-600 py-2 px-3 mr-2 text-white"
                  onClick={this.showEditModal}
                  disabled={loading}>
                  Edit
                </button>
              )}
            </div>
            <div className="flex items-center mt-4">
              {this.props.mySubscription?.active && (
                <button
                  disabled={cancelSubLoading}
                  className="rounded bg-red-700 hover:bg-red-600 py-2 px-3 mr-2 text-white"
                  onClick={this.confirmCancelSubscription}>
                  {cancelSubLoading ? 'Cancelling...' : 'Cancel Subscription'}
                </button>
              )}
              {(!subscriptionManager?.isProPlan ||
                subscriptionManager?.isFreePlan) && (
                <button
                  className="rounded bg-teal-500 hover:bg-teal-600 py-2 px-3 mr-2 text-white"
                  onClick={this.upgradeSubscription}
                  disabled={loading}>
                  Upgrade Subscription
                </button>
              )}
            </div>
          </>
        )}
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  ...state.userProfile,
  mySubscription: state.subscriptions.user,
  products: state.subscriptions.products,
  authUser: state.auth.user,
})

export default connect(
  mapStateToProps,
  UserProfileReducer.actionCreators,
)(withRouter(UserProfileModal))
